import { DashboardComponent } from './layout/containers/dashboard/dashboard.component';
import { Routes } from '@angular/router';
import { SignInComponent } from '@user/containers/sign-in/sign-in.component';
import { adminGuard } from './services/admin.guard';
import { authGuard } from '@app/services/auth.guard';
import { buyedRoutes } from '@app/pages/buy-ed/buy-ed.routes';
import { paymentsRoutes } from './pages/payments/payments-page.routes';
import { registeredChipsRoutes } from '@app/pages/registered-chips/registered-chips.routes';

export const routes: Routes = [
    {
        path: 'sign-in',
        component: SignInComponent,
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./layout/containers/general-info/general-info.component')
                .then((m) => m.GeneralInfoComponent),
            },
            {
                path: 'clinic-list',
                loadComponent: () =>
                    import('./pages/clinic/clinic.component').then((m) => m.ClinicComponent),
                canActivate: [adminGuard]
            },
            {
                path: 'veterinarians/:clinicId',
                loadComponent: () =>
                    import(
                        './pages/clinic/containers/veterinarians/veterinarians.component'
                    ).then((m) => m.VeterinariansComponent),
            },
            {
                path: 'chip-registration',
                loadComponent: () =>
                    import('./pages/chip-registration/chip-registration.component').then(
                        (m) => m.ChipRegistrationComponent,
                    ),
            },
            {
                path: 'buy-ed',
                loadComponent: () =>
                    import('./pages/buy-ed/buy-ed.component').then((m) => m.BuyEdComponent),
                children: [...buyedRoutes],
            },
            {
                path: 'registered-chips',
                loadComponent: () =>
                    import('./pages/registered-chips/registered-chips.component').then(
                        (m) => m.RegisteredChipsComponent,
                    ),
                children: [...registeredChipsRoutes],
            },
            {
                path: 'payments',
                loadComponent: () =>
                    import('./pages/payments/payments-page.component').then(
                        (m) => m.PaymentsPageComponent,
                    ),
                children: [...paymentsRoutes],
            },
            {
                path: 'settings',
                loadComponent: () =>
                    import('./pages/settings/settings-page.component').then(
                        (m) => m.SettingsPageComponent,
                    ),
            },
            {
                path: 'terms',
                loadComponent: () =>
                    import('./pages/terms-conditions/terms-conditions.component').then(
                        (m) => m.TermsConditionsComponent,
                    ),
            },
            {
                path: 'privacy-policy',
                loadComponent: () =>
                    import('./pages/privacy-policy/privacy-policy.component').then(
                        (m) => m.PrivacyPolicyComponent,
                    ),
            },
            {
                path: '**',
                redirectTo: '',
            },
        ],
    },
    {
        path: 'set-password',
        loadComponent: () =>
            import('./shared/containers/set-password/set-password.component').then(
                (m) => m.SetPasswordComponent,
            ),
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
];

